import React, { useContext, useMemo, useCallback } from 'react';
import { BusinessCollectionCompType } from '../../../../../Types/ObjektVy';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import {
  LeverantorQuery_node_TEDLRLeverantor as leverantor_node,
  LeverantorQuery as leverantor,
  LeverantorQueryVariables as leverantorVariables,
  LeverantorQuery_node_TEDLRLeverantor__Associations as Associations,
} from '../../../Leverantor/ObjektVyer/Leverantor/_QueryTypes/LeverantorQuery';
import UpdateMutation from './Test2LeverantorUpdateMutation.gql';
import AddMutation from './Test2LeverantorAddMutation.gql';
import LeverantorQuery from './Test2LeverantorQuery.gql';
import {
  LeverantorUpdateMutation as IUpdateData,
  LeverantorUpdateMutationVariables as IUpdateVariables,
} from '../../../Leverantor/ObjektVyer/Leverantor/_QueryTypes/LeverantorUpdateMutation';
import {
  LeverantorAddMutation as IAddData,
  LeverantorAddMutationVariables as IAddVariables,
} from '../../../Leverantor/ObjektVyer/Leverantor/_QueryTypes/LeverantorAddMutation';
import BusinessDataForm, {
  BusinessDataFormContext,
  useBusinessDataFormContext,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import { ObjektVyKort } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import Attribut from '../../../_Common/Components/BusinessCollectionComponents/Attribut/Attribut';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import { useMutation, useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { ObjektLank } from '../../../_Common/Components/BusinessCollectionComponents/ObjektLank/ObjektLank';
import {
  AssociationList,
  IAssociationListConfig,
} from '../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import { OrgPersLokGruppForm } from '../../../OP/ObjektVyer/OrgPersLok/OrgPersLok';
import AssocieradObjektVy from '../../../_Common/Components/BusinessCollectionComponents/AssocieradObjektVy/AssocieradObjektVy';
import { ObjektVyFaltLista } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyFaltLista/ObjektVyFaltLista';
import AttributGrupp from '../../../_Common/Components/BusinessCollectionComponents/AttributGrupp/AttributGrupp';
import {
  removeIdsFromNewAssociations,
  IFormData,
  IFieldValidations,
  IValidateFn,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import UtbetalningssattQuery from './Test2UtbetalningssattQuery.gql';
import {
  UtbetalningssattQuery as UtbetalningssattQueryData,
  UtbetalningssattQueryVariables,
} from '../../../Leverantor/ObjektVyer/Leverantor/_QueryTypes/UtbetalningssattQuery';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import { leverantorFormStateActionTransformer } from '../../../Leverantor/ObjektVyer/Leverantor/Utils/leverantorUtils';
import AttributeHeader from '../../../../../Components/Attributes/AttributeHeader/AttributeHeader';
import {
  TEDLRLeverantorSTATUSEnum,
  TEDOPOrgPersLokTypEnum,
  TEDOPOrgPersLokLOKALADREnum,
  TEDOPOrgPersLokREGELEnum,
  TEDInputLRLeverantorAddValues,
  TEDSelectionConditionType,
  TEDSelectionOperator,
} from '../../../../../globalQueryTypes';
import ObjectSubCard from '../../../_Common/Components/ObjectSubCard';
import { definedSelectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';
import { useSelectedDetailQuery } from '../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';
import FieldGroupStatusIndicator from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Components/FieldGroupStatusIndicator/FieldGroupStatusIndicator';
import EDButton from '../../../../../BaseComponents/Buttons/Button/EDButton';
import shortid from 'shortid';
import { ICustomValidValues } from '../../../../../Types/ColumnDefType';
import { head } from 'ramda';
import { convertTEDUrvalToUIUrval } from '../../../../../Components/Urval/Utils/convertTEDUrvalToUIUrval';
import { collectionMap } from '../../../../../Model/ModelContext/ModelContext';

const leverantormodel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRLeverantor;

const fakturamodel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRLeverantorfaktura;

const validBanks: ICustomValidValues = {
  skipDefaultValues: false,
  validValuesFunction: (defaultValues, formState) => {
    return formState?.currentValues?.['KONTO_NR']?.endsWith('2')
      ? [{ name: 'secret bank', value: head(defaultValues)?.value ?? 'sorry' }]
      : defaultValues.filter(
          option => option.data?._Associations?.Land?.LANDKOD !== 'IE'
        );
  },
  dataDependencies: ['Land.LANDKOD'],
  urval: convertTEDUrvalToUIUrval(
    'SYSBank',
    [
      [
        {
          namn: 'POSTNUMMER',
          typ: TEDSelectionConditionType.Value,
          valueCondition: { op: TEDSelectionOperator.hasvalue },
        },
      ],
    ],
    collectionMap
  ).unsafelyUnwrap(),
};
const validateSparrdatum: IValidateFn<leverantor_node> = ({
  currentValues,
  touched,
}) => {
  const validations: IFieldValidations = [];
  const regDatum = Date.parse(currentValues.REGDATUM);
  const sparrDatum = Date.parse(currentValues.SPARRAD_FROM_DATUM);
  const fsDatum = Date.parse(currentValues.FSKATT_KONTROLLERAD_DATUM);

  if (currentValues.RABATT && currentValues.RABATT < 0) {
    validations.push({
      fieldName: 'RABATT',
      message: 'Rabatt får inte vara negativ, i alla fall inte enligt KO',
      type: 'Error',
    });
  }

  if (currentValues.RABATT && currentValues.RABATT > 1.0) {
    validations.push({
      fieldName: 'RABATT',
      message: 'Tänker du betala för att bli av med eländet?!',
      type: 'Hint',
    });
  }

  if (currentValues.RABATT == 0.21) {
    validations.push({
      fieldName: 'RABATT',
      message: 'Får inte vara 21',
      type: 'Error',
      showAsHint: touched.RABATT ? false : true,
    });
  }

  if (currentValues.RABATT == 0.43) {
    validations.push({
      type: 'RequiredValueHint',
      message: 'Måste ha värde när rabatt är 43%',
      fieldName: 'SPARRAD_FROM_DATUM',
      showAsHint: touched.SPARRAD_FROM_DATUM ? false : true,
    });
    if (!currentValues.SPARRAD_FROM_DATUM) {
      validations.push({
        fieldName: 'SPARRAD_FROM_DATUM',
        type: 'MissingValue',
      });
    }

    validations.push({
      type: 'RequiredValueHint',
      message: 'Måste ha värde när rabatt är 43%',
      fieldName: 'Moms',
      path: ['Moms'],
      showAsHint: touched._Associations?.Moms ? false : true,
    });
    if (!currentValues._Associations?.Moms) {
      validations.push({
        fieldName: 'Moms',
        path: ['Moms'],
        type: 'MissingValue',
      });
    }
  }

  if (sparrDatum && regDatum && sparrDatum < regDatum) {
    validations.push({
      fieldName: 'SPARRAD_FROM_DATUM',
      message: 'Leverantör kan inte spärras innan registreringsdatum',
      type: 'Error',
    });
  }

  if (fsDatum && regDatum && fsDatum < regDatum) {
    validations.push({
      fieldName: 'FSKATT_KONTROLLERAD_DATUM',
      message: 'F-skatt kontrollerad innan registreringsdatum?',
      type: 'Warning',
    });
  }

  currentValues._Associations?.LevBetalningssatt?.forEach((betSatt: any) => {
    if (betSatt.KONTO_NR === '123456789')
      validations.push({
        fieldName: 'KONTO_NR',
        path: ['LevBetalningssatt', betSatt.id],
        message: 'Är detta ett test?',
        type: 'Warning',
      });
    if (betSatt.NUMERISKA_FAKTURANR === 'NEJ' && betSatt.OCR === 'JA')
      validations.push({
        fieldName: 'OCR',
        path: ['LevBetalningssatt', betSatt.id],
        message: 'OCR kräver numeriska fakturanummer',
        type: 'Error',
      });
  });

  currentValues._Associations?.Attestforslag?.forEach((forslag: any) => {
    if (forslag.REFERENS === 'David')
      validations.push({
        fieldName: 'REFERENS',
        path: ['Attestforslag', forslag.id],
        message: 'Denna person är inte pålitlig',
        type: 'Error',
      });
    if (forslag.REFERENS === 'Eniac')
      validations.push({
        fieldName: 'REFERENS',
        path: ['Attestforslag', forslag.id],
        message: 'Välj en fysisk person',
        type: 'Warning',
      });
    if (forslag.REFERENS && !forslag.REFERENS.includes(' '))
      validations.push({
        fieldName: 'REFERENS',
        path: ['Attestforslag', forslag.id],
        message: 'Ange förnam och efternamn',
        type: 'Hint',
      });
  });

  if (currentValues.KUNDNR === '7704') {
    validations.push({
      fieldName: 'RABATT',
      message: 'Värde krävs',
      type: 'RequiredValueHint',
    });
    if (currentValues.RABATT == null) {
      validations.push({
        fieldName: 'RABATT',
        message: 'Värde krävs',
        type: 'MissingValue',
      });
    }
  }

  return validations;
};

const validateBank: IValidateFn<leverantor_node> = ({ currentValues }) => {
  const validations: IFieldValidations = [];
  currentValues._Associations?.LevBetalningssatt?.forEach(betSatt => {
    if (betSatt.KONTO_NR === '123456') {
      if (!betSatt?._Associations?.Bank?.id) {
        validations.push({
          fieldName: '',
          path: ['LevBetalningssatt', betSatt.id, 'Bank'],
          message: 'Värde krävs',
          type: 'MissingValue',
        });
      }
      validations.push({
        fieldName: '',
        path: ['LevBetalningssatt', betSatt.id, 'Bank'],
        message: 'Värde krävs',
        type: 'RequiredValueHint',
      });
    }
  });

  return validations;
};

const levBetalningssattConfig: IAssociationListConfig = {
  inCard: true,
  integrated: true,
  defaultVisningstyp: 'tabell',
  customDefaultColumns: [
    { attributeDef: 'IDString', caption: 'Utbetalningssätt', header: true },
    { attributeDef: 'KONTO_NR' },
    { attributeDef: 'NUMERISKA_FAKTURANR' },
    { attributeDef: 'OCR' },
    {
      association: 'Bank',
      attributeDef: '',
      customValidValues: validBanks,
    },
  ],
  customBusinessConfig: { associations: { Bank: { disableArrowIcon: true } } },
};

const BetalningssattButtons: React.FC<React.PropsWithChildren<{}>> = () => {
  const formcontext = useBusinessDataFormContext();
  const formcontextUpdate = formcontext?.update;

  const läggTill = useCallback(() => {
    const id = 'New_LevBetalningssatt' + shortid();
    formcontextUpdate?.([
      {
        associationName: 'LevBetalningssatt',
        operation: 'Add_Values',
        id: id,
        values: { NUMERISKA_FAKTURANR: '' },
      },
    ]);
  }, [formcontextUpdate]);
  return (
    <>
      <EDButton
        label={'Lägg till'}
        onClick={läggTill}
        disabled={!formcontext?.formState.editMode}
      />
    </>
  );
};

const SubFormButtons: React.FC<React.PropsWithChildren<{}>> = () => {
  const formcontext = useBusinessDataFormContext();
  const formcontextUpdate = formcontext?.update;
  const formStateDispatch = formcontext?.formStateDispatch;
  const parentFormStateDispatch =
    formcontext?.parentFormContext?.formStateDispatch;

  const cancel = useCallback(() => {
    formStateDispatch?.({ type: 'CANCEL' });
  }, [formStateDispatch]);

  const ok = useCallback(() => {
    if (formcontext?.formState.values) {
      parentFormStateDispatch?.({
        type: 'UPDATE',
        value: formcontext.formState.values,
      });
    }
    formStateDispatch?.({
      type: 'CANCEL',
    });
  }, [
    formcontext?.formState.values,
    formStateDispatch,
    parentFormStateDispatch,
  ]);

  const läggTill = useCallback(() => {
    const id = 'New_LevBetalningssatt' + shortid();
    formcontextUpdate?.([
      {
        associationName: 'LevBetalningssatt',
        operation: 'Add_Values',
        id: id,
        values: { NUMERISKA_FAKTURANR: '' },
      },
    ]);
  }, [formcontextUpdate]);
  return (
    <>
      <EDButton
        label="Avbryt"
        onClick={cancel}
        marginRight={1}
        disabled={
          !(
            formcontext?.formState.editMode &&
            formcontext.formState.formHasChanged
          )
        }
      />
      <EDButton
        label="Ok"
        onClick={ok}
        marginRight={1}
        disabled={
          !(
            formcontext?.formState.editMode &&
            formcontext?.formState.formHasChanged &&
            !formcontext?.formState.validation.some(
              val => val.type === 'Error' || val.type === 'MissingValue'
            )
          )
        }
      />
      <EDButton
        label={'Lägg till'}
        onClick={läggTill}
        disabled={!formcontext?.formState.editMode}
      />
    </>
  );
};

const TestRutin2VyComp: BusinessCollectionCompType = props => {
  const id = props.id ? props.id : '';
  const { nodeData, loading: nodeLoading } = useSelectedDetailQuery<
    leverantor,
    leverantor_node,
    leverantorVariables
  >(LeverantorQuery, props.id);

  const [mutation, { loading, error }] = useMutation<
    IUpdateData,
    IUpdateVariables
  >(UpdateMutation);

  const [addMutation, addStatus] = useMutation<IAddData, IAddVariables>(
    AddMutation
  );

  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const attestforslagConfig = useMemo<IAssociationListConfig>(() => {
    return {
      defaultVisningstyp: 'tabell',
      integrated: true,
      hideToolbar: false,
      inCard: true,
      customDefaultColumns: [
        {
          attributeDef: 'ANVANDS_FOR',
        },
        {
          attributeDef: 'GILTIG_FOR',
        },
        {
          attributeDef: 'REFERENS',
        },
        {
          attributeDef: 'AKTIV',
          disableEditMode: true,
        },
        { attributeDef: 'IDString', caption: 'Referens', header: true },
        {
          association: 'MottagandeEnhet',
          attributeDef: 'Namn',
          caption: 'Mottagande enhet',
          disableEditMode: true,
        },
        {
          association: 'Fakturakod',
          attributeDef: 'BENAMNING',
          caption: 'Fakturakod',
          disableAssociationLink: true,
        },
        //   {
        //     attributeDef: 'Attestratt.AttestNamnTitel',
        //     caption: 'Beslutsattestant',
        //   },
        //   {
        //     attributeDef: 'MottagningsAttestRatt.AttestNamnTitel',
        //     caption: 'Mottagningsattestant',
        //   },
        //   {
        //     attributeDef: 'MottagandeEnhet.Namn',
        //     caption: 'Mottagande enhet',
        //   },
      ],
      isCellDisabled: params => {
        return (
          params.row.GILTIG_FOR === 'OVRIGA_FAKTUROR' ||
          (params.field === 'GILTIG_FOR' &&
            params.row.GILTIG_FOR === 'KOB_FAKTUROR')
        );
      },
    };
  }, []);

  const updateFunction = useCallback(
    (values: IFormData) => {
      const newValues = removeIdsFromNewAssociations(values);
      return mutation({
        variables: {
          db: activeDatabase || '',
          values: {
            id: definedSelectedId(id),
            _version: nodeData ? nodeData._version : 1,
            ...newValues,
          },
        },
      });
    },
    [mutation, activeDatabase, id, nodeData]
  );

  const addFunction = useCallback(
    (values: IFormData) => {
      return addMutation({
        variables: {
          db: activeDatabase || '',
          values: values as TEDInputLRLeverantorAddValues,
        },
      });
    },
    [addMutation, activeDatabase]
  );
  const initialOrgNamn =
    typeof props.id === 'object' &&
    typeof props.id?.customDetailData === 'string'
      ? props.id?.customDetailData
      : 'Ny Organisations AB';
  const { data: utbetalningssattData } = useQuery<
    UtbetalningssattQueryData,
    UtbetalningssattQueryVariables
  >(UtbetalningssattQuery, {
    variables: { databaseName: activeDatabase || '' },
    skip: !activeDatabase,
  });
  return (
    <BusinessDataForm<leverantor_node>
      isNew={props.isNew}
      data={nodeData}
      model={leverantormodel}
      updateMutation={updateFunction}
      addMutation={addFunction}
      fullScreen={props.config?.fullPage ?? false}
      mutationError={error || addStatus.error}
      mutationLoading={loading || addStatus.loading}
      formStateActionTransformer={leverantorFormStateActionTransformer(
        utbetalningssattData?.db?.SYSUtbetalningssatt_All || [],
        nodeData?.OPTyp ?? null
      )}
      newFormContext
      initialValue={{
        STATUS: TEDLRLeverantorSTATUSEnum.NORMAL,
        _Associations: {
          OrgPers_Values: {
            _typ: TEDOPOrgPersLokTypEnum.OVRIGORG,
            ORG_NAMN: initialOrgNamn,
            REGEL: TEDOPOrgPersLokREGELEnum.STANDARD,
            LOKALADR: TEDOPOrgPersLokLOKALADREnum.LOKAL,
            _Associations: {
              Adress_Values: {},
            },
          },
          Leverantorskategori_Ref: null,
        },
      }}
      validateFns={[
        validateSparrdatum as IValidateFn,
        validateBank as IValidateFn,
      ]}
    >
      <ObjektVy nodeLoading={nodeLoading} editImplemented>
        <ObjektVySida
          sidNr={1}
          caption="Leverantör"
          collectionName={leverantormodel.CollectionName}
        >
          <ObjektVyKolumner>
            <ObjektVyKolumn fullPage={props.config?.fullPage ?? false}>
              <AttributGrupp>
                <AttributeHeader
                  attributeGroups={[
                    'LEVERANTORSNR',
                    'OrgPers.ORG_NAMN',
                    ['OrgPers.FORNAMN', 'OrgPers.EFTERNAMN'],
                  ]}
                />
                <Attribut<leverantor_node> name="LEVERANTORSNR" mode="edit" />
                <Attribut<leverantor_node> name="KUNDNR" />
              </AttributGrupp>
              <ObjektVyKort>
                <AssocieradObjektVy
                  association={leverantormodel.Associations.OrgPers}
                  vy={
                    <OrgPersLokGruppForm
                      autoFocus={props.isNew}
                      association={leverantormodel.Associations.OrgPers}
                    />
                  }
                />
              </ObjektVyKort>
              <ObjektVyKort caption="Betalningsinformation">
                <ObjektVyFaltLista>
                  <ObjektLank<Associations>
                    associationName="Betalningsvillkor"
                    id={
                      nodeData &&
                      nodeData._Associations &&
                      nodeData._Associations.Betalningsvillkor
                        ? nodeData._Associations.Betalningsvillkor.id
                        : null
                    }
                  />
                  <ObjektLank<Associations>
                    associationName="Valuta"
                    id={
                      nodeData &&
                      nodeData._Associations &&
                      nodeData._Associations.Valuta
                        ? nodeData._Associations.Valuta.id
                        : null
                    }
                  />
                  <Attribut<leverantor_node> name="RIKSBANKSKOD" />
                </ObjektVyFaltLista>
                <ObjectSubCard>
                  <AssociationList
                    associationName="LevBetalningssatt"
                    associationPath="LevBetalningssatt"
                    collectionName={leverantormodel.CollectionName}
                    ownId={definedSelectedId(id)}
                    config={levBetalningssattConfig}
                  />
                  <BetalningssattButtons />
                </ObjectSubCard>
              </ObjektVyKort>
              <ObjektVyKort caption="Underformulär för betalningssätt">
                <BusinessDataForm
                  localValuesInChildForm
                  model={leverantormodel}
                  validateFns={[
                    validateSparrdatum as IValidateFn,
                    validateBank as IValidateFn,
                  ]}
                >
                  <AssociationList
                    associationName="LevBetalningssatt"
                    associationPath="LevBetalningssatt"
                    collectionName={leverantormodel.CollectionName}
                    ownId={definedSelectedId(id)}
                    config={levBetalningssattConfig}
                  />
                  <SubFormButtons />
                </BusinessDataForm>
              </ObjektVyKort>
            </ObjektVyKolumn>
            <ObjektVyKolumn fullPage={props.config?.fullPage ?? false}>
              <AttributGrupp caption="Övrigt">
                <FieldGroupStatusIndicator
                  collectionName={leverantormodel.CollectionName}
                  fields={[
                    'ANGE_KUNDNR_SOM_FAKTREF',
                    'RABATT',
                    'REGDATUM',
                    'SPARRAD_FROM_DATUM',
                    'FSKATT_KONTROLLERAD_DATUM',
                    'Leverantorskategori',
                    'Leveransvillkor',
                    'Moms',
                    'ORDINARIE_REFERENS_TYP',
                  ]}
                  fullWidth={true}
                />
                <Attribut<leverantor_node> name="ANGE_KUNDNR_SOM_FAKTREF" />
                <Attribut<leverantor_node> name="RABATT" />
                <Attribut<leverantor_node> name="REGDATUM" />
                <Attribut<leverantor_node> name="SPARRAD_FROM_DATUM" />
                <Attribut<leverantor_node> name="FSKATT_KONTROLLERAD_DATUM" />
                <ObjektLank<Associations>
                  associationName="Leverantorskategori"
                  id={
                    nodeData &&
                    nodeData._Associations &&
                    nodeData._Associations.Leverantorskategori
                      ? nodeData._Associations.Leverantorskategori.id
                      : null
                  }
                />
                <ObjektLank<Associations>
                  associationName="Leveransvillkor"
                  id={
                    nodeData &&
                    nodeData._Associations &&
                    nodeData._Associations.Leveransvillkor
                      ? nodeData._Associations.Leveransvillkor.id
                      : null
                  }
                />
                <ObjektLank<Associations>
                  associationName="Moms"
                  id={
                    nodeData &&
                    nodeData._Associations &&
                    nodeData._Associations.Moms
                      ? nodeData._Associations.Moms.id
                      : null
                  }
                />
                <Attribut<leverantor_node> name="ORDINARIE_REFERENS_TYP" />
              </AttributGrupp>

              <BusinessDataFormContext.Consumer>
                {formContext => (
                  <ObjektVyKort caption="LEVERANTÖRSFAKTURAREFERENSER">
                    {id && (
                      <AssociationList
                        associationName="Attestforslag"
                        associationPath="Attestforslag"
                        collectionName={leverantormodel.CollectionName}
                        config={attestforslagConfig}
                        ownId={definedSelectedId(id)}
                      />
                    )}
                    <EDButton
                      label={'Lägg till'}
                      onClick={() => {
                        const id = 'New_Attestforslag_' + shortid();
                        formContext?.update([
                          {
                            associationName: 'Attestforslag',
                            operation: 'Add_Values',
                            id: id,
                          },
                        ]);
                      }}
                    />
                    <span> </span>
                    <EDButton
                      label={'Rensa'}
                      onClick={() => {
                        formContext?.formState?.currentValues?._Associations?.Attestforslag?.forEach(
                          (forslag: any) => {
                            formContext?.update([
                              {
                                associationName: 'Attestforslag',
                                operation: 'Delete_Values',
                                id: forslag.id,
                              },
                            ]);
                          }
                        );
                      }}
                    />
                  </ObjektVyKort>
                )}
              </BusinessDataFormContext.Consumer>
            </ObjektVyKolumn>
          </ObjektVyKolumner>
        </ObjektVySida>
        <ObjektVySida
          disableMasonry
          sidNr={2}
          caption="Fakturor"
          columns={1}
          collectionName={fakturamodel.CollectionName}
          leftMenuPresent
        >
          {/*  FIXME: Bättre lösning? */}
          {id && (
            <AssociationList
              collectionName={leverantormodel.CollectionName}
              ownId={definedSelectedId(id)}
              associationName="Fakturor"
            />
          )}
        </ObjektVySida>
      </ObjektVy>
    </BusinessDataForm>
  );
};

export const testRutin2Vy = collectionCompToObjektVy(
  TestRutin2VyComp,
  'testRutin2Vy'
);
